function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.35 14.075C19.3 13.9125 19.1812 13.7812 19.0312 13.7L14.6936 11.5376C14.3999 11.3876 14.0436 11.4938 13.8749 11.7688L12.4936 14.075L12.0561 13.9563C9.14372 13.1625 6.83732 10.8563 6.04372 7.94388L5.92497 7.50638L8.23117 6.12513C8.50617 5.95638 8.61241 5.60013 8.46241 5.30637L6.30001 0.968774C6.21876 0.818774 6.08751 0.706274 5.92501 0.650014C5.76251 0.600014 5.58125 0.618764 5.43751 0.706264L1.73751 2.75626C0.78751 3.2875 0.37501 4.4375 0.78127 5.45006L1.93127 8.32507C3.70003 12.7501 7.25007 16.3001 11.6751 18.0689L14.5563 19.2189C14.8125 19.3251 15.0813 19.3751 15.3563 19.3751C16.1375 19.3751 16.8625 18.9501 17.2438 18.2626L19.2938 14.5688C19.3813 14.4188 19.4 14.2375 19.35 14.075Z"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.f4a62397.svg";
export { ForwardRef as ReactComponent };